import { Component, Input } from '@angular/core';
import { Breadcrumb } from '../../../core/models/breadcrumb.model';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumb[];

  trackByUrl(breadcrumb: Breadcrumb): string {
    return breadcrumb.url;
  }
}
